<h1 *ngIf="isNewOrganisation">Organisation erstellen</h1>
<form [formGroup]="organisationEditForm">
    <div class="form-field-content">
        <div class="form-field-inputs">
            <mat-form-field class="wid-full">
                <mat-label>Name der Organisation</mat-label>
                <input matInput formControlName="name"
                    (input)="changeDomainToName(nameInputField.value)" required #nameInputField
                    [errorStateMatcher]="orgaNameErrorStateMatcher" maxlength="161" (blur)="trimField('name')"/>
                <mat-error>
                    {{ utilService.getFormControlErrorMessage(name, {includeMinLength: true}) }}
                </mat-error>
            </mat-form-field>
            <div>
                <h2>Rechnungsadresse</h2>
                <div class="columns-50-50">
                    <!-- <mat-form-field>
                            <mat-select
                                placeholder="Art der Organisation"
                                formControlName="type"
                                required
                                [disabled]="!isNewOrganisation"
                            >
                                <mat-option value="PRODUCT_PROVIDER">
                                    Produktanbieter
                                </mat-option>
                                <mat-option
                                    *ngIf="isUserPlatformAdmin()"
                                    value="PRODUCT_TYPE_ASSOCIATION"
                                >
                                    Fachgruppe
                                </mat-option>
                                <mat-option value="CERTIFICATION_PROVIDER">
                                    Zertifizierungsanbieter
                                </mat-option>
                                <mat-option value="CERTIFICATION_OFFICE">
                                    Zertifizierungsdienstleister
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="type.hasError">
                                Dieses Feld darf nicht leer sein.
                            </mat-error>
                        </mat-form-field> -->
                        <mat-form-field>
                            <mat-label>Straße</mat-label>
                            <input
                                matInput
                                formControlName="street"
                                required
                                (blur)="trimField('street')"
                            /><mat-error *ngIf="street.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                            <mat-error *ngIf="!street.hasError('required') && street.hasError('specialCharFound')">
                                Bitte keine Sonderzeichen benutzen
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Hausnummer</mat-label>
                            <input
                                matInput
                                formControlName="hNr"
                                required
                                (blur)="trimField('hNr')"
                            /><mat-error *ngIf="hNr.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                            <mat-error *ngIf="hNr.hasError('maxlength')">
                                Hausnummer ist zu lang
                            </mat-error>
                            <mat-error *ngIf="!hNr.hasError('maxlength') && hNr.hasError('pattern')">
                                Bitte gültige Hausnummer eingeben
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Postleitzahl</mat-label>
                            <input
                                matInput
                                formControlName="postalCode"
                                required
                                (blur)="trimField('postalCode')"
                            /><mat-error *ngIf="postalCode.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                            <mat-error *ngIf="!postalCode.hasError('required') && postalCode.hasError('pattern')">
                                Bitte eine gültige Postleitzahl eingeben
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Ort</mat-label>
                            <input
                                matInput
                                formControlName="city"
                                required
                                (blur)="trimField('city')"
                            /><mat-error *ngIf="city.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                            <mat-error *ngIf="!city.hasError('required') && city.hasError('pattern')">
                                Bitte mindestens zwei Zeichen eingeben und das erste Zeichen bitte groß schreiben.
                            </mat-error>
                        </mat-form-field>
                        <!-- <mat-form-field>
                            <input
                                matInput
                                placeholder="Kurzbezeichnung"
                                formControlName="domain"
                                #domainInputField
                            />
                            <span matPrefix>{{ domainPrefix }}</span>
                            <mat-error *ngIf="domain.hasError">
                                Dieses Feld darf nicht leer sein.
                            </mat-error>
                        </mat-form-field> -->
                        <mat-form-field class="wid-full">
                            <mat-label>Website</mat-label>
                            <input
                                matInput
                                formControlName="url"
                                type="url"
                                (blur)="trimField('url')"
                            />
                            <mat-error *ngIf="url.hasError('websiteLength')">
                                Die Website darf maximal 60 Zeichen lang sein
                            </mat-error>
                            <mat-error *ngIf="url.hasError('invalidUrl') && !url.hasError('websiteLength')">
                                Bitte eine valide Website angeben
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Telefonnummer</mat-label>
                            <input
                              matInput
                              formControlName="phoneNumber"
                              autocomplete="tel"
                              (blur)="checkPhonenumber()"
                            />
                            <mat-error
                            *ngIf="phoneNumber.invalid"
                            >
                                Bitte geben Sie eine gültige Telefonnummer ein</mat-error
                            >
                        </mat-form-field>
                </div>
            </div>
            <!-- <form #form="ngForm">
                    <app-text-editor
                        [(editorText)]="organisation.description"
                        (textValidityChange)="onDescriptionValidityChange($event)"
                    ></app-text-editor>
                </form> -->
            <div>
                <div>
                    <div class="description-container">
                        <label for="description">Kurzbeschreibung der Organisation</label>
                        <textarea #descriptionCtrl
                        formControlName="description"
                        name="description" id="description"
                        maxlength="500"
                        placeholder="Hier Beschreibung einfügen"
                        [ngClass]="{'error-border': description.touched && description.errors?.maxLength}"
                        ></textarea>
                        <span *ngIf="description.touched && description.errors?.maxLength"
                            class="custom-error-message">Bitte geben Sie eine Beschreibung ein</span>
                        <span class="letter-counter">{{ description.value.length }} / 500</span>
                    </div>
                    <div class="contact-container">
                        <div class="contact-header">
                            <h2>Kontakt</h2>
                            <mat-icon
                                matSuffix
                                class="info-icon"
                                matTooltip="Demo- und Angebotsanfragen von der Produktseite werden an diesen Kontakt gesendet. Ist kein Kontakt hinterlegt, sind diese Funktionen deaktiviert."
                                matTooltipPosition="above"
                                tabindex="-1"
                                >
                                info_outline
                            </mat-icon>
                        </div>
                        <mat-slide-toggle formControlName="createContact"  class="mg">
                            Kontakt erstellen
                        </mat-slide-toggle>
                        <div *ngIf="organisationEditForm.get('createContact')?.value" formGroupName="contact" class="columns-50-50">
                            <mat-form-field>
                                <mat-label>Name der Kontaktperson</mat-label>
                                <input matInput formControlName="contactName" required (blur)="trimField('contactName', 'contact')"/>
                                <mat-error *ngIf="contactName.hasError('required')">
                                    Bitte einen Namen angeben
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>E-Mail</mat-label>
                                <input matInput formControlName="email" required (blur)="trimField('email', 'contact')"/>
                                <mat-error *ngIf="contactEmail.hasError('required') || contactEmail.hasError('email')">
                                    Bitte gültige E-Mail angeben
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <app-logo [fileId]="organisation.fileId" (logoChanged)="organisation.fileId = $event"></app-logo>
            <p class="logo-info" *ngIf="isNewOrganisation">
                Wenn Sie eine neue Organisation auf der Plattform einstellen, werden
                Sie automatisch der Administrator dieser Organisation.
            </p>
            <p class="logo-info">Die hier eingegebenen Informationen werden - bis auf die Firmenadresse - öffentlich
                sichtbar.</p>
        </div>
    </div>


    <div class="form-btn-container">
        <span class="info-txt">*Pflichtfeld</span>
        <div>
            <button matButton="elevated" color="warn" (click)="onAbort()">
                Abbrechen
            </button>
            <button matButton="elevated" class="green-confirm" (click)="onOrganisationConfirm()"
                [disabled]="organisationEditForm.invalid || !organisation.fileId">
                Weiter
            </button>
        </div>
    </div>
</form>

<div *ngIf="isLoading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>
